export type {};

declare global {
  interface Number {
    toFloat(): number;
    toInt(radix?: number): number;
    toNumber(radix?: number): number;
  }

  interface NumberConstructor {
    isNumber(arg: any): arg is number;
  }
}

if (!Number.isNumber) {
  Number.isNumber = function (arg: any): arg is number {
    return typeof arg === 'number';
  };
}

const { prototype } = Number;

if (!prototype.toFloat) {
  Object.defineProperty(prototype, 'toFloat', {
    writable: false,
    enumerable: false,
    value: function (this: number): number {
      return this;
    }
  });
}

if (!prototype.toInt) {
  Object.defineProperty(prototype, 'toInt', {
    writable: false,
    enumerable: false,
    value: function (this: number): number {
      return this;
    }
  });
}

if (!prototype.toNumber) {
  Object.defineProperty(prototype, 'toNumber', {
    writable: false,
    enumerable: false,
    value: function (this: number): number {
      return this;
    }
  });
}
